import type { InjectionKey } from 'vue'
import type { Toast } from '~/utils/toast'

export interface MediaControls {
  togglePlay: () => Promise<void>
  seek: (deltaSeconds: number) => void

  duration: Readonly<Ref<number>>
  currentTime: Ref<number>
}

export const CONTAINER_KEYS = ['content', 'aside', 'toc'] as const

export type ContainerKey = (typeof CONTAINER_KEYS)[number]

export const NAVIGATION_CONTEXTS = ['marketing', 'default'] as const

export type NavigationContext = (typeof NAVIGATION_CONTEXTS)[number]

/**
 * Dependency injection keys. Use these to inject dependencies into components.
 *
 * Example:
 * const toast = inject(diKeys.toast)
 *
 * Add new keys using Symbols to avoid collisions:
 * export const diKeys = {
 *   ...
 *   myNewKey: Symbol('myNewKey') as InjectionKey<MyType>,
 * }
 */
export const diKeys = {
  toast: 'ksToast' as unknown as InjectionKey<Toast>,
  article: Symbol('article') as InjectionKey<Ref<CrystallizeArticle>>,
  mediaControls: Symbol('mediaControls') as InjectionKey<MediaControls>,
  containers: Symbol('containers') as InjectionKey<Record<ContainerKey, Readonly<Ref<HTMLDivElement | null>>>>,
  navigationContext: Symbol('navigationContext') as InjectionKey<NavigationContext>,
}
